import React, { useState, useEffect } from 'react'
import gsap from 'gsap'

import "./header.css"

import aboutIcon from "../assets/about.svg"
import exitIcon from "../assets/exit.svg"
import servicesIcon from "../assets/services.svg"
import contactIcon from "../assets/contact.svg"
import homeIcon from "../assets/home.svg"
import menuIcon from "../assets/menu.svg"
import downIcon from "../assets/down.svg"
import sashaLogo from '../assets/logo6.svg'

const Header = (props) => {

  const [ Toggle, setToggle ] = useState(false)
  const [ toggleBlog, setToggleBlog ] = useState('blogContainer hidden')
  const [ exitBlog, setExitBlog ] = useState('exitBlog hidden')
  const [ darkenHeader, setDarkenHeader ] = useState(false)
  const [ concernsMenu, setConcernsMenu ] = useState(false)
  const [ concernsClass, setConcernsClass ] = useState( "nav__concerns__menu" )
  const [ servicesClass, setServicesClass] = useState( "nav__services__menu" )

  const openLightbox = props.openLightbox

  const makeBlogVisible = () =>
  {
    setToggleBlog('blogContainer')
    setExitBlog('exitBlog')
  }

  const closeBlog = () =>
  {
    setToggleBlog('blogContainer hidden')
    setExitBlog('exitBlog hidden')
  }

  const openConcernsMenu = () =>
  {
          setConcernsMenu(true)
      setConcernsClass("nav__concerns__menu visible")
  }

  const closeConcernsMenu = () =>
  {
      setConcernsMenu(false)
      setConcernsClass("nav__concerns__menu")
  }

  const openServicesMenu = () =>
    {
        setServicesClass("nav__services__menu visible")
    }
  
    const closeServicesMenu = () =>
    {
        setServicesClass("nav__services__menu")
    }

  // Detect scroll position
  const handleNavigation = (e) =>
  {
    if(document.documentElement.scrollTop > 0)
    {
      setDarkenHeader(true)
    }
    else
    {
      setDarkenHeader(false)
    }
  }

  // open lightbox
  const delayedOpenLightbox1 = () =>
  {
    gsap.delayedCall(0.5, () => { openLightbox( "Injectables", 1 ) })
  }

  const delayedOpenLightbox2 = () =>
  {
    gsap.delayedCall(0.5, () => { openLightbox( "Laser & Energy Devices", 2 ) })
  }

  const delayedOpenLightbox3 = () =>
  {
    gsap.delayedCall(0.5, () => { openLightbox( "Aesthetic Treatments", 3 ) })
  }

  useEffect(() =>
  {
    window.addEventListener("scroll", () => handleNavigation())

    return () =>
    {
      window.removeEventListener("scroll", () => handleNavigation())
    }
  }, [])

  return (
    <header className={ darkenHeader ? 'header darken' : 'header' }>
      <div className={exitBlog} onClick={closeBlog}>
        <div className='exitBlogLine1'/>
        <div className='exitBlogLine2' />
      </div>
      
          
        <nav className="nav container">
          <a href="index.html" className="nav__logo">
            <img src={sashaLogo} alt="" />
          </a>

          

          <div className={ Toggle ? "nav__menu show-menu" : "nav__menu" }>
            <ul className="nav__list grid">
              {/* <li className="nav__item nav__home__item">
                <a href="#home" className="nav__link active-link">
                  <img src={homeIcon} className="nav__icon" alt="" />
                  Home
                </a>
              </li> */}

              <li className="nav__item">
                <a href="#about" className="nav__link">
                  <img src={aboutIcon} className="nav__icon" alt="" />
                  About
                </a>
              </li>

              <li className="nav__item">
                <a href="#services" className="nav__link" onMouseOver={openServicesMenu} onMouseLeave={closeServicesMenu}>
                  <img src={servicesIcon} className="nav__icon" alt="" /> 
                  <div>
                    Services&nbsp;
                    <img className='dropArrow nav__droparrow' src={downIcon} alt="" />
                  </div>
                  <div className={servicesClass}>
                    <ul>
                      <li>
                        <a onClick={delayedOpenLightbox1}  href="#services" className="nav__link__menu active-link">
                        Botox
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox1}  href="#services" className="nav__link__menu active-link">
                        Dermal Fillers
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox1}  href="#services" className="nav__link__menu active-link">
                        Full Face <br />
                        Rejuvenation
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox1}  href="#services" className="nav__link__menu active-link">
                        Hyperhidrosis <br />
                        (Excessive Sweating)
                        </a>
                      </li>
                    </ul>
                    <ul>
                      <li>
                        <a onClick={delayedOpenLightbox1} href="#services" className="nav__link__menu active-link">
                          IPL
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox1} href="#services" className="nav__link__menu active-link">
                          PicoSure
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox1} href="#services" className="nav__link__menu active-link">
                          Laser Hair <br />
                          Removal
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox1} href="#services" className="nav__link__menu active-link">
                          Non-Ablative <br />
                          Fractional Laser
                        </a>
                      </li>
                    </ul>
                    <ul className='services__middle__box'>
                      <li>
                        <a onClick={delayedOpenLightbox2} href="#services" className="nav__link__menu active-link">
                          TempSure® RF
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox2} href="#services" className="nav__link__menu active-link">
                          FlexSure® RF
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox2} href="#services" className="nav__link__menu active-link">
                          SculpSure®
                          <br />
                          <br />
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox2} href="#services" className="nav__link__menu active-link">
                          Potenza® RF <br />
                          Microneedling
                        </a>
                      </li>
                    </ul>
                    <ul className='services__right__box'>
                      <li>
                        <a onClick={delayedOpenLightbox3} href="#services" className="nav__link__menu active-link">
                          Chemical Peels
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox3} href="#services" className="nav__link__menu active-link">
                          Hydrafacials®
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox3} href="#services" className="nav__link__menu active-link">
                          Advanced Medical <br />
                           Skincare
                        </a>
                      </li>
                    </ul>
                  </div>
                </a>
              </li>

              <li className="nav__item nav__concerns__link">
                <a href="#concerns" className="nav__link" onMouseOver={openConcernsMenu} onMouseLeave={closeConcernsMenu}> 
                  <div className='nav__concerns'>
                    Concerns&nbsp;
                    <img className='dropArrow' src={downIcon} alt="" />
                  </div>
                  <div className={concernsClass}>
                    {/* Column 1 */}
                    <ul>
                      <li>
                        <a onClick={delayedOpenLightbox1}  href="#services" className="nav__link__menu active-link">
                          Fine Lines & Wrinkles
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox1} href="#services" className="nav__link__menu active-link">
                          Eye Rejuvenation
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox1} href="#services" className="nav__link__menu active-link">
                          Jawline Contouring
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox2} href="#services" className="nav__link__menu active-link">
                          Body Contouring
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox2} href="#services" className="nav__link__menu active-link">
                          Skin Resurfacing
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox1} href="#services" className="nav__link__menu active-link">
                          Excessive <br /> Sweating
                        </a>
                      </li>                      
                    </ul>
                    {/* Column 2 */}
                    <ul>
                      <li>
                        <a onClick={delayedOpenLightbox1} href="#services" className="nav__link__menu active-link">
                          Volume Loss
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox1} href="#services" className="nav__link__menu active-link">
                        Tear Troughs
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox2} href="#services" className="nav__link__menu active-link">
                          Skin Tightening
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox2} href="#services" className="nav__link__menu active-link">
                          Double Chin
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox2} href="#services" className="nav__link__menu active-link">
                          Stretch Marks
                        </a>
                      </li>
                      <li>
                        <a  href="#services" className="nav__link__menu active-link">
                          Acne & <br />
                          Acne Scarring
                        </a>
                      </li>
                    </ul>
                    {/* Column 3 */}
                    <ul>
                      <li>
                        <a onClick={delayedOpenLightbox2} href="#services" className="nav__link__menu active-link">
                          Sun Damage
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox2} href="#services" className="nav__link__menu active-link">
                          Rosacea
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox2} href="#services" className="nav__link__menu active-link">
                          Facial Veins
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox2} href="#services" className="nav__link__menu active-link">
                          Unwanted Hair
                        </a>
                      </li>
                      <li>
                        <a onClick={delayedOpenLightbox2} href="#services" className="nav__link__menu active-link">
                          Melasma
                        </a>
                      </li>                  
                      <li>
                        <a onClick={delayedOpenLightbox2} href="#services" className="nav__link__menu active-link">
                          Brown Spots, <br /> Pigmentation
                        </a>
                      </li>
                    </ul>
                  </div>
                  
                </a>

                
              </li>

              <li className="nav__item">
                <a href="#contact" className="nav__link">
                  <img src={contactIcon} className="nav__icon" alt="" />
                  Contact
                </a>
              </li>
              {/* <li className="nav__item">
                <a href="#blog" className="nav__link" onClick={makeBlogVisible}>
                  <img src={servicesIcon} className="nav__icon" alt="" /> 
                  Blog
                </a>
              </li> */}

            
            </ul>

            <i className='nav__close' onClick={() => setToggle(!Toggle)}><img src={exitIcon} className="nav__icon" alt="" /></i>
          </div>

          <div className={ Toggle ? 'nav__toggle hidden' : 'nav__toggle' } onClick={() => setToggle(!Toggle)}>
            <i></i>
            <img src={menuIcon} className="nav__icon" alt="" />
          </div>
          <p className='nav__phone'>519-641-3000</p>  
        </nav>
    </header>
  )
}

export default Header